const validateCBWebChat = () => {
  const chatBotContainer = document.querySelector("#chat-bots-webchat-container");
  if (chatBotContainer && window.CBWebChat) return true;
  return false;
};

const hide = () => {
  if (validateCBWebChat()) window.CBWebChat.hide();
};

const show = () => {
  if (validateCBWebChat()) window.CBWebChat.show();
};

const setChatVariable = (key: string, value: string) => {
  if (validateCBWebChat()) window.CBWebChat.setChatVariable(key, value);
};

export const initializeChatBot = () => {
  if (!document.querySelector("#chat-bot-script")) {
    const script = document.createElement("script");
    script.src = "https://chat-bots.scadco.com/webChat?bot=121476439157@w.us";
    script.id = "chat-bot-script";
    script.async = true;
    script.onload = () => console.info("Successful loading of the ChatBot");
    script.onerror = () => console.error("Error loading of the ChatBot");
    document.body.appendChild(script);
  }
};

export const chatBot = { hide, show, setChatVariable };
